
import RcDomainMap from "../../../common/RcDomainMap.js";
import Result from './Result.js';
import StringUtils from "@/utils/StringUtils.js";
import AnswerMap from "../../answer/AnswerMap.js";

export default class ResultMap extends RcDomainMap {
  static MODEL_NAME = Result.MODEL_NAME  + "Map";
  
  constructor(domain, data) {
    super(domain, data, ResultMap.MODEL_NAME);
  }

  copy() {
    var data = this._copy();
    return new ResultMap(this.domain, data);
  }
  
  find() {
    var keys = this.keys();
    var found = new ResultMap(this.domain, {} );
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var data = this.domain.results().findById(key);
      var item = new Result(this.domain, data);
      if (!item.isNew()) {
        found.add(item);
      }
    }
    
    return found;
  }
  
  list() {
    var values = [];
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getResult(key);
      values.push(item);
    }
    return values;
  }
  
  getResult(key) {
    var value = super.get(key);
    return new Result(this.domain, value);
  }
  
  addResult(result) {
    super.add(result);
    return this;
  }
  
  addResults(results) {
    super.addAll(results);
    return this;
  }
  
  vehicle() {
    var found = new ResultMap(this.domain, {} );
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getResult(key);
      if (item.vehicle().find().isVehicle()) {
        found.add(item);
      }
    }
    return found;
  }
  
  trailers() {
    var found = new ResultMap(this.domain, {} );
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getResult(key);
      if (item.vehicle().find().isTrailer()) {
        found.add(item);
      }
    }
    return found;
  }
  
  forVehicle(vehicle) {
    var found = new ResultMap(this.domain, {} );
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getResult(key);
      if (item.vehicle().id() === vehicle.id()) {
        found.add(item);
      }
    }
    return found;
  }
  
  initial() {
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getResult(key);
      if (item.isInitial()) {
        return item;
      }
    }
    return new Result(this.domain, {});
  }
  
  odometer() {
    return this.initial().odometer();
  }
  
  schedule() {
    return this.initial().schedule();
  }

  location() {
    return this.initial().location();
  }

  defectType() {
    return this.initial().mostSevereUnfixedDefectType();
  }

  defectTypeDisplay() {
    return this.initial().defectTypeDisplay();
  }

  createdDateDisplay() {
    return this.initial().createdDateDisplay();
  }

  initials() {
    var keys = this.keys();
    var map = new ResultMap(this.domain);
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getResult(key);
      if (item.isInitial()) {
        map.add(item);
      }
    }
    return map;
  }
  
  enroute() {
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getResult(key);
      if (item.isEnroute()) {
        return item;
      }
    }
    return new Result(this.domain, {});
  }
  
  enroutes() {
    var map = new ResultMap(this.domain);
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getResult(key);
      if (!item.isInitial()) {
        map.add(item);
      }
    }
    return map;
  }
  
  isAttached() {
    return this.initial().isAttached();
  }

  mostSevereUnfixedDefectType(includeDetached) {
    var keys = this.keys();
    var mostSevere = Result.Values.DefectType.DEFECT_TYPE_NONE;
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getResult(key);
      if (item.isDetached() && !includeDetached) {
        continue;
      }
      var defectType = item.mostSevereUnfixedDefectType();
      if (StringUtils.eic(defectType, Result.Values.DefectType.DEFECT_TYPE_MAJOR)) {
        mostSevere = defectType;
        break;
      } else if (StringUtils.eic(defectType, Result.Values.DefectType.DEFECT_TYPE_MINOR)) {
        if (StringUtils.eic(mostSevere, Result.Values.DefectType.DEFECT_TYPE_MAJOR)) {
          continue;
        }
        mostSevere = defectType;
      } else {
        if (StringUtils.eic(mostSevere, Result.Values.DefectType.DEFECT_TYPE_MAJOR)) {
          continue;
        }
        if (StringUtils.eic(mostSevere, Result.Values.DefectType.DEFECT_TYPE_MINOR)) {
          continue;
        }
        mostSevere = defectType;
      }
    }
    
    return mostSevere;
  }

  answers() {
    let map = new AnswerMap(this.domain);
    for (let key in this.keys()) {
      let result = this.getResult(key);
      map.addAll(result.answers());
    }
    return map;
  }

  load() {
    let results = this.find();
    this.addAll(results);

    let answerMap = this.answers().find();
    let answerOptions = answerMap.options();
    let optionMap = answerOptions.find();
    for (let key in this.keys()) {
      let obj = this.getResult(key);
      let matching = answerMap.findAll(obj.answers().keys());
      let matchingOptions = optionMap.findAll(matching.options().keys());
      for (let answerId of matching.keys()) {
        let answer = matching.getAnswer(answerId);
        answer.withOptions(matchingOptions.findAll(answer.options().keys()));
      }
      obj.withAnswers(matching);
    }

    let repairs = answerMap.repairs();
    repairs = repairs.find();
    for (let key of answerMap.keys()) {
      let answer = answerMap.getAnswer(key);
      let repairsForAnswer = repairs.findAll(answer.repairs().keys());
      let optionsForRepairs = repairsForAnswer.options().find();
      for (let repairId of repairsForAnswer.keys()) {
        let repair = repairsForAnswer.getRepair(repairId);
        repair.withOption(optionsForRepairs.getOption(repair.option().id()));
      }
      answer.withRepairs(repairsForAnswer);
    }
    return this;
  }
}